import * as types from "./types";
import _ from 'lodash';

export const defaultState = {
  bookings: {},
  rental_bookings: {},
  request_types: {
    fetching: false,
    deleting: false,
    sending: false,
    fetching_price: false
  },
  rental_price: null,
  deleting_booking: null,
  errors: []
};

const mergeBookings = (state, action) => {
  let bookings = {};
  if (state.bookings[action.productId]) {
    const merged_bookings = [...state.bookings[action.productId], ...action.bookings];
    const uniq_bookings = _.uniqBy(merged_bookings, 'created_at');
    bookings = { ...state.bookings, [action.productId]: uniq_bookings };
  } else {
    bookings = { ...state.bookings, [action.productId]: [...action.bookings] };
  }
  return bookings;
}

const mergeRentalBookings = (state, action) => {
  let bookings = {};
  if (state.rental_bookings[action.productId]) {
    const merged_bookings = [...state.rental_bookings[action.productId], ...action.bookings];
    const uniq_bookings = _.uniqBy(merged_bookings, 'created_at');
    bookings = { ...state.rental_bookings, [action.productId]: uniq_bookings };
  } else {
    bookings = { ...state.rental_bookings, [action.productId]: [...action.bookings] };
  }
  return bookings;
}

const bookings = (state = defaultState, action) => {
  switch (action.type) {
    case types.FETCHING_RENTAL_PRICE:
      return {
        ...state,
        request_types: { ...state.request_types, fetching_price: true }
      }
    case types.FETCHED_RENTAL_PRICE:
      return {
        ...state,
        rental_price: action.price_details,
        request_types: { ...state.request_types, fetching_price: false }
      }
    case types.FETCHED_BOOKINGS:
      return {
        ...state,
        bookings: !action.rentals && mergeBookings(state, action),
        rental_bookings: action.rentals && mergeRentalBookings(state, action),
        request_types: { ...state.request_types, fetching: false }
      }
    case types.ADDED_BOOKING:
      return {
        ...state,
        bookings: { ...state.bookings, [action.booking.product_guid]: [...state.bookings[action.booking.product_guid], action.booking] },
        request_types: { ...state.request_types, sending: false }
      }
    case types.DELETED_BOOKING:
      let current_bookings = { ...state.bookings };
      _.remove(current_bookings[action.booking.product_guid], { guid: action.booking.guid });
      return {
        ...state,
        bookings: { ...current_bookings },
        request_types: { ...state.request_types, deleting: false, deleting_booking: null }
      }
    case types.DELETING_BOOKING:
      return {
        ...state,
        request_types: { ...state.request_types, deleting: true, deleting_booking: action.booking.guid }
      }
    case types.FETCHING_BOOKINGS:
      return {
        ...state,
        request_types: { ...state.request_types, fetching: true }
      }
    case types.ADDING_BOOKING:
      return {
        ...state,
        request_types: { ...state.request_types, sending: true }
      }
    case types.ERROR_FETCHING_RENTAL_PRICE:
    case types.ERROR_DELETING_BOOKING:
    case types.ERROR_FETCHING_BOOKINGS:
    case types.ERROR_ADD_BOOKING:
      return {
        ...state,
        errors: [...state.errors, action.error],
        loading: defaultState.request_types,
        request_types: {
          fetching: false,
          deleting: false,
          sending: false,
          fetching_price: false
        }
      }
    default:
      return state;
  }
};
export default bookings;
